import React from 'react';
import ChatInterface from '../components/Assessment/ChatInterface';

const AssessmentPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-4xl px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">
            Assessment AI Readiness
          </h1>
          <p className="mt-2 text-lg text-gray-600">
            Rispondi alle nostre domande per ricevere una valutazione personalizzata
          </p>
        </div>
        
        <ChatInterface />
      </div>
    </div>
  );
};

export default AssessmentPage;